import { BaseDto } from './base.dto';

export class OrderTypeDto extends BaseDto {
  id: number;
  name: string;
}
